<template>
    <router-link to="/user" v-if="isWriting==false">
        <button class="center" style="margin-top: 1.4em;">
            <b class = "white-text">{{ $t("home.btnregister") }}</b>
        </button>
    </router-link>
</template>

<script>
export default {
    props: ['text', 'isWriting']
}
</script>

<style scoped>
    button{
        height: 60px !important;
        width: 317px !important;
        border-radius: 20px;
        background-color: #357c38;
        border: 3px solid white;
        
        z-index: 90;
        cursor: pointer;
    }

    @media screen and (max-width: 670px) {
      button {
        width: 100% !important;
      }
    }
</style>
